import { translate } from '@comparacar/lib/src/translations'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import Button from '@mui/material/Button'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import { useRouter } from 'next/router'
import React, { useEffect, useState } from 'react'

const SortMenu = () => {
  const router = useRouter()
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const [selected, setSelected] = useState<string>('price-asc')
  const open = Boolean(anchorEl)

  useEffect(() => {
    router.query?.sort !== undefined ? setSelected(router.query.sort as string) : setSelected('price-asc')
  }, [router])

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleSelect = (value: string) => {
    router.push({
      pathname: router.pathname,
      query: {
        ...router.query,
        page: 1,
        sort: value
      }
    })
    handleClose()
  }

  const names = {
    'price-asc': translate('SortMenu.priceAsc') as string,
    'price-desc': translate('SortMenu.priceDesc') as string,
    'consumption-desc': translate('SortMenu.consumptionDesc') as string,
    'km-asc': translate('SortMenu.kmAsc') as string
  }

  return (
    <div>
      <Button
        size="small"
        variant="outlined"
        endIcon={<KeyboardArrowDownIcon />}
        onClick={handleClick}
        sx={{ color: 'text.secondary', textTransform: 'none' }}
      >
        Ordenar: {names[selected]}
      </Button>
      <Menu id="basic-menu" anchorEl={anchorEl} open={open} onClose={handleClose}>
        <MenuItem selected={selected === 'price-asc'} onClick={() => handleSelect('price-asc')} value="price-asc">
          {names['price-asc']}
        </MenuItem>
        <MenuItem selected={selected === 'price-desc'} onClick={() => handleSelect('price-desc')} value="price-desc">
          {names['price-desc']}
        </MenuItem>
        <MenuItem selected={selected === 'km-asc'} onClick={() => handleSelect('km-asc')} value="km-asc">
          {names['km-asc']}
        </MenuItem>
        <MenuItem
          selected={selected === 'consumption-desc'}
          onClick={() => handleSelect('consumption-desc')}
          value="consumption-desc"
        >
          {names['consumption-desc']}
        </MenuItem>
      </Menu>
    </div>
  )
}

export default SortMenu
